import React from 'react';
import { MentalKnowHowTipsData } from '../../types';

type Props = {
    tips: MentalKnowHowTipsData,
    color: string,
}

class TipsAndTricks extends React.Component<Props> {
    componentDidMount() {
        // @ts-ignore
        new window.Swiper ('.swiper-container', {
            direction: 'horizontal',
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    render() {
        const { tips, color } = this.props;
        return (
            <div className="tips-container" style={{ backgroundColor: color }}>
                <div className="swiper-container">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img src={tips.tipsIconUrl} className="tips-icon" alt="" />
                            <p className="swiper-slide-hint">Swipe nach links oder rechts</p>
                        </div>
                        {tips.sliderTips.map(tip => ((
                            <div className="swiper-slide" key={tip.id}>
                                <div className="tips-slide-title">{tip.title}</div>
                                <div className="tips-slide-content" dangerouslySetInnerHTML={{ __html: tip.text }} />
                            </div>
                        )))}
                    </div>
                    <div className="swiper-button-prev swiper-button-white" />
                    <div className="swiper-button-next swiper-button-white" />
                </div>
            </div>
        );
    }
}

export default TipsAndTricks;
